import React from 'react';
import MainContentTitle from "../components/maincontent/MainContentTitle";



export default function Languages() {
    return (
        <div>
            <MainContentTitle title={'Languages'} />
            <h5>English</h5>
            <p>Well, probably this doesn't look as it is written by a professional writer, not a native person, and the
                main reason is that I'm neither of them.</p>
            <p>For good or for bad this is my level. (Probably for bad for the English language).</p>
            <h5>Spanish</h5>
            <p>Ay caramba! xD</p>
            <p>Creo que he visto bastante televisión española para poder decir que soy nativo.</p>
            <p>Quizá no me vereis escribiendo con acentos porqué uso un teclado americano y tengo que acordarme de memória
            donde estan todas las tildes. Y probablemente podreis identificar alguna que otra falta ortográfica.
                Otra razón por la cual normalmente escribo sin acentos, así eso queda mas disimulado.</p>
            <h5>Japanese</h5>
            <p>これは本当に私の書いたテキストです。五年間日本に住んでいましたけど日本語を少し使いませんでした。あまり学ばせんでした。
            最後年日本で働きた時日本語のぺらぺらと言われたようになったけど今辞書とググルを使わなければいけません。ほとんど忘れしまいました。</p>
            <p>日本から戻った時、バルセロナでちょっと日本語ほ勉強しましたけどあの日本二住んでいた時日本語のレベルに届けません。</p>
            <h5>Serbian</h5>
            <p>али треба да рекам хрватскосрпски? како се каже serbocroatian на српском?</p>
            <p>знам, пишем на ћирилицом онда ово је српски, није хрватски, right?</p>
            <p>студирао сам мало српски језик затошто мој најбољи пријатељи су српски. забављам се кад пробам да причам на
                српском, али, ако хоћеш да ти кажем истину, немам појма што рекам.</p>
            <h5>Catalan</h5>
            <p>De fet, la meva llengua materna es el català. Em passa el mateix que en castellà però, que faig servir
            un teclat americà i m'haig d'enrecordar de memòria a on estan tots els accents els apòstrofs i tot.</p>
            <p>També faré alguna que altra falta d'ortografia, no sóc Xoriguera.</p>
        </div>
    );
}